import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ModalFooter } from 'syf-component-library/ui/patterns/SlideInModal';
import { FooterContainer } from 'syf-component-library/ui/patterns/SlideInModal/subcomponents';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { Body, H4 } from 'syf-component-library/ui/typography';
import { DATA_OBJECT, DATA_TYPE } from '../../../const/analytics';
import { FAL_EXCLAMATION_TRIANGLE } from '../../../const/iconProps';
import MainContext from '../../../Context';
import { colors } from '../../../defaultTheme';
import { useIsErrorView } from '../../../store/multiPaymentAtoms';
import { t } from '../../../strings/i18n';
import { CardRowCLWrapper } from '../PaymentModalStates/subcomponents';
const Content = styled(Body) `
  max-width: 381px;
`;
const ErrorContainer = styled(Inset) `
  display: flex;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
`;
export const CardError = () => {
    const { handleClose } = useContext(MainContext);
    const [, setIsErrorView] = useIsErrorView();
    useEffect(() => {
        setIsErrorView(true);
    }, [setIsErrorView]);
    return (_jsxs(_Fragment, { children: [_jsxs(ErrorContainer, Object.assign({ bottom: "xxlarge", top: "xlarge" }, { children: [_jsx(FontAwesomeIcon, { color: colors.warning, icon: FAL_EXCLAMATION_TRIANGLE, size: "5x" }), _jsx(Inset, Object.assign({ bottom: "large", top: "base" }, { children: _jsx(CardRowCLWrapper, Object.assign({ centerChildren: true, centerText: true }, { children: _jsx(H4, { children: t('errors.paymentDetailsUnavailable') }) })) })), _jsx(CardRowCLWrapper, Object.assign({ centerChildren: true, centerText: true }, { children: _jsx(Content, { children: t('errors.paymentDetailsUnavailableInfo') }) }))] })), _jsx(Stack, { size: "xxlarge" }), _jsx(FooterContainer, { children: _jsx(ModalFooter, { dataPrimaryObject: DATA_OBJECT.BUTTON, dataPrimaryReason: "close", dataType: DATA_TYPE.MAKE_A_PAYMENT, handlePrimaryButton: handleClose, primaryText: t('button.close') }) })] }));
};
